var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-stage",
        { ref: "stage", attrs: { config: _vm.config } },
        [
          _c(
            "v-layer",
            { ref: "layer" },
            _vm._l(_vm.drawnZones(), function (zone) {
              return _c(
                "v-group",
                {
                  key: zone.uniqueId,
                  ref: "group-" + zone.uniqueId,
                  refInFor: true,
                  attrs: { data: zone, config: zone.config.group },
                  on: {
                    mousedown: _vm.handleGroupMousedown,
                    dragend: _vm.handleGroupDragend,
                  },
                },
                [
                  _c("v-line", {
                    ref: "line-" + zone.uniqueId,
                    refInFor: true,
                    attrs: { config: zone.config.line, data: zone },
                    on: { click: _vm.handleLineClick },
                  }),
                  _vm._v(" "),
                  _vm._l(zone.vertices, function (point) {
                    return _vm.draggable
                      ? _c("v-circle", {
                          key: point.uniqueId,
                          ref: "circle-" + point.uniqueId,
                          refInFor: true,
                          attrs: {
                            data: point,
                            config: zone.config.circles,
                            x: point.ui.x,
                            y: point.ui.y,
                            radius: 4,
                            visible: zone.selected,
                          },
                          on: {
                            dragmove: _vm.handleCircleDragmove,
                            mouseenter: _vm.handleCircleMouseenter,
                            mouseleave: _vm.handleCircleMouseleave,
                          },
                        })
                      : _vm._e()
                  }),
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }